import {Injectable} from '@angular/core';
import {PatientDto} from '../../features/patient-management/dtos/patient.dto';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  storePatient(patient: PatientDto): void {
    this.setItem('patient', JSON.stringify(patient));
  }

  loadPatient(): PatientDto | undefined {
    let patientString = this.getItem('patient');
    if (patientString === '') {
      return undefined;
    }

    return JSON.parse(patientString);
  }

  removePatient(): void {
    this.removeItem('patient');
  }

  getItem(key: string): string {
    try {
      return sessionStorage.getItem(key) + '';
    } catch (e) {
    }
    return '';
  }

  setItem(key: string, value: string) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
    }
  }

  removeItem(key: string) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
    }
  }
}
